import { DeeplinkHandlerInput } from "."

export const deeplinkUrl = ({ url }: DeeplinkHandlerInput) => {
  window.location.assign(url)
}